/**
 * Table export and Excel import, replacing jquery tableExport and the old excel.js.
 */
import * as XLSX from 'xlsx';

const BOOK_TYPES = { xlsx: 'xlsx', xls: 'biff8', csv: 'csv', excel: 'xlsx' };

/** exportFile(tableId, type): download an HTML table as a spreadsheet (default xlsx). */
export function exportFile(id, type = 'xlsx') {
    const table = document.getElementById(id);
    if (!table) return;
    const time = new Date().getTime();
    const bookType = BOOK_TYPES[type] || 'xlsx';
    const ext = bookType === 'biff8' ? 'xls' : bookType;
    const wb = XLSX.utils.table_to_book(table, { raw: true });
    XLSX.writeFile(wb, `export_${time}.${ext}`, { bookType });
}

/**
 * ExportToTable(input, fn): read the first sheet of the chosen .xlsx/.xls file
 * and pass its rows (array of objects keyed by header) to fn.
 */
export function ExportToTable(input, fn) {
    const el = typeof input === 'string' ? document.querySelector(input) : input;
    const regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xlsx|.xls)$/;
    const name = (el?.value || '').toLowerCase();
    if (!regex.test(name)) {
        window.alert('Please upload a valid Excel file!');
        return;
    }
    const file = el.files && el.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
        const workbook = XLSX.read(new Uint8Array(e.target.result), { type: 'array' });
        const first = workbook.SheetNames[0];
        const rows = XLSX.utils.sheet_to_json(workbook.Sheets[first]);
        if (rows.length > 0) fn(rows);
    };
    reader.readAsArrayBuffer(file);
}
